<template>
  <div class="d-flex flex-column ga-2 mt-2 overflow-auto" v-if="step == 'main'">
    <QRView :link="link" :alias="alias" :image="image" :name="name"
            :q-color="qrStore.settings.color"
            :b-color="qrStore.settings.backgroundColor"
            :q-image="qrStore.settings.imageFileBase64 || qrStore.KTIcon"
            ref="QRViewRef"/>
    <ShareKit :link-to-copy="link" :title="name" :before-share="handleBeforeShare" :file="sharedFile">
      <v-btn variant="flat" color="primary" rounded="lg" class="w-100" :loading="isLoading">
        {{$t('Поделиться')}}
      </v-btn>
    </ShareKit>


    <v-btn variant="outlined" color="accent" rounded="lg" @click="openSettings">{{$t('Настроить QR')}}</v-btn>
    <v-btn variant="outlined" color="accent" rounded="lg" @click="downloadPNG"><v-icon :icon="DownloadIcon" color="BW-500" size="24" class="mr-2"/>PNG</v-btn>
  </div>

  <div v-else-if="step == 'settings'" class="d-flex flex-column overflow-hidden">
    <v-hover>
      <template #default="{ isHovering, props }">
        <v-icon :icon="BackIcon" v-bind="props" :color="isHovering ? 'primary' : 'accent'" size="24" class="cursor-pointer" @click="closeSettings('main')"/>
      </template>
    </v-hover>
    <div class="d-flex flex-column align-center ga-4 overflow-auto">
      <div class="text-center color-title">{{$t('Настройка QR')}}</div>
      <div class="background-block pa-6" :style="{backgroundColor: bColor}">
        <div class="qr-block pa-3">
          <ClientOnly>
            <QRCodeVue3 myclass="qr" :value="link" :key="qrKey" :width="168" :height="168"
                        :image="qImage || qrStore.KTIcon"
                        :image-options="imageOptions"
                        :dots-options="{ type: 'extra-rounded', color: qColor, roundSize: true, gradient: null }"
                        :corners-dot-options="{ type: '', color: qColor }"
                        :corners-square-options="{ type: 'extra-rounded', color: qColor}"/>
          </ClientOnly>
        </div>
      </div>
      <div class="w-100">
        <label class="field-label">{{$t('Цвет кода')}}</label>
        <div class="d-flex ga-2">
          <div class="color-field" :style="{backgroundColor: qColor}" @click="openChooseColorDialog(qColor)"></div>
          <v-text-field
              variant="outlined"
              hide-details="auto"
              density="compact"
              rounded="lg"
              bg-color="#fff"
              maxlength="7"
              :rules="[v => /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/.test(v) || 'Неверный формат']"
              v-model="qHexColor"
              @input="handleQInput"
              clearable
          >
            <template v-slot:clear>
              <v-hover>
                <template v-slot:default="{ props }">
                  <v-icon :icon="ClearIcon" v-bind="props" @click="qColor = qHexColor = '#000000'"/>
                </template>
              </v-hover>
            </template>
          </v-text-field>
        </div>
      </div>
      <div class="w-100">
        <label class="field-label">{{$t('Цвет фона')}}</label>
        <div class="d-flex ga-2">
          <div class="color-field" :style="{backgroundColor: bColor}" @click="openChooseColorDialog(bColor, false)"></div>
          <v-text-field
              variant="outlined"
              hide-details="auto"
              density="compact"
              rounded="lg"
              bg-color="#fff"
              maxlength="7"
              :rules="[v => /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/.test(v) || 'Неверный формат']"
              v-model="bHexColor"
              @input="handleBInput"
              clearable
          >
            <template v-slot:clear>
              <v-hover>
                <template v-slot:default="{ props }">
                  <v-icon :icon=" ClearIcon" v-bind="props" @click="bColor = bHexColor = '#0D87EF'"/>
                </template>
              </v-hover>
            </template>
          </v-text-field>
        </div>
      </div>

      <div class="w-100">
        <label class="field-label">{{$t('Иконка')}}</label>
        <div class="file-block d-flex" :class="{'selected': previewUrl}">
          <v-file-input
              ref="fileInput"
              v-model="rawFile"
              accept="image/jpeg,image/png,image/gif,image/svg+xml"
              class="d-none"
              @update:model-value="validateFile"
          ></v-file-input>
          <template v-if="!previewUrl">
            <div class="text">
              {{$t('Разрешение от 150 × 150 пикс, размер не больше 4 МБ. Формат: JPG, PNG, GIF, SVG')}}
            </div>
            <v-btn variant="outlined" color="accent" rounded="lg" @click="fileInput.click()" size="small">{{$t('Выбрать файл')}}</v-btn>
            <div v-if="error" class="text-error text-caption ml-3" style="max-width: 200px; line-height: 1.2;">
              {{ $t(error) }}
            </div>
          </template>
          <template v-else>
            <div class="d-flex align-center ga-2 overflow-hidden separate">
              <v-avatar
                  v-if="previewUrl"
                  size="48"
                  rounded="sm"
              >
                <v-img :src="previewUrl" cover></v-img>
              </v-avatar>
              <div class="file-name">{{rawFile?.name || 'image'}}</div>
            </div>
            <div class="d-flex ga-2 align-center overflow-hidden separate justify-end">
              <v-btn variant="outlined" color="accent" rounded="lg" @click="fileInput.click()" size="small">{{$t('Заменить')}}</v-btn>
              <v-btn variant="outlined" color="accent" rounded="lg" @click="invalidate()" size="small" style="padding: 0; min-width: 32px"><v-icon :icon="TrashIcon"/></v-btn>
            </div>
          </template>
        </div>
      </div>
      <v-btn variant="flat" color="primary" rounded="lg" class="w-100" @click="applySettings" :disabled="!isColorValid">
        {{$t('Применить')}}
      </v-btn>
    </div>
  </div>
  <div v-else class="d-flex flex-column overflow-hidden">
    <v-hover>
      <template #default="{ isHovering, props }">
        <v-icon :icon="BackIcon" v-bind="props" :color="isHovering ? 'primary' : 'accent'" size="24" class="cursor-pointer" @click="closeSettings()"/>
      </template>
    </v-hover>

    <div class="d-flex flex-column align-center ga-2 overflow-auto pr-2">
      <div class="text-center color-title">{{$t('Настройка цвета')}}</div>
      <ColorPicker @change-color="changeColor" hide-eye-dropper :default-color="cColor" :swatch-colors="colors"/>
      <v-btn variant="flat" color="primary" rounded="lg" class="w-100" @click="applyColor">
        {{$t('Применить')}}
      </v-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
import QRCodeVue3 from "qrcode-vue3";
import {computed, onMounted, ref, watch} from "vue";
import BackIcon from "~/assets/icons/back.vue";
import DownloadIcon from "~/assets/icons/download.vue";
import {useDialogStore} from "@/stores/dialogStore";
import {useColorStore} from "@/stores/colorStore";
import ClearIcon from "~/assets/icons/clear.vue";
import TrashIcon from "~/assets/icons/edit/trash.vue";
import QRView from "@/components/dialogs/QRView.vue";
import {useQrSettingsStore} from "@/stores/qrSettingsStore";
import {useBGColor} from "@/composables/useBGColor";

const props = defineProps({
  id: { type: Number },
  alias: { type: String },
  name: { type: String },
  image: { type: String },
  lang: { type: String },
  defaultLang: { type: String },
});

const imageOptions = {
  hideBackgroundDots: true,
  imageSize: 0.4,
  margin: 6
}

const step = ref('main')

const qImage = ref()
const config = useRuntimeConfig()
const host = config.public.tapLink;
const link = ref('')
const qrStore = useQrSettingsStore()
const dialogStore = useDialogStore()
const colorStore = useColorStore()
const bgColor = useBGColor()

const colors = ref()

onMounted(async () => {
  await qrStore.fetchSettings(props.alias);
  link.value = `https://${host}/${props.alias}${props.defaultLang != props.lang ? '/' + props.lang : ''}`
})

const openSettings = () => {
  dialogStore.setShowCloseIcon(false)
  qColor.value = qrStore.settings.color
  const qValues = qColor.value.match(/\d+(\.\d+)?/g).map(Number);
  if(qValues.length >= 3) {
    qHexColor.value = rgbaToHex(...qValues)
  } else {
    qHexColor.value = qColor.value
  }
  bColor.value = qrStore.settings.backgroundColor
  const bValues = bColor.value.match(/\d+(\.\d+)?/g).map(Number);
  if(bValues.length >= 3) {
    bHexColor.value = rgbaToHex(...bValues)
  } else {
    bHexColor.value = bColor.value
  }

  qImage.value = qrStore.settings.imageFileBase64
  if(qImage.value) {
    previewUrl.value = qImage.value
  }
  step.value = 'settings'
}

const qrColorChange = ref(false)
const openChooseColorDialog = async (color, qr = true) => {
  qrColorChange.value = qr
  cColor.value = formatColor(color)
  colors.value = await colorStore.get(props.id)
  dialogStore.setShowCloseIcon(false)
  step.value = 'color'
}

const closeSettings = (s = 'settings') => {
  if (s == 'main') {
    dialogStore.setShowCloseIcon(true)
  }
  step.value = s
}

const applySettings = () => {
  qrStore.saveSettings(props.alias, {
    backgroundColor: bColor.value,
    color: qColor.value,
    imageFileBase64: qImage.value
  })

  closeSettings('main')
}

const applyColor = () => {
  colorStore.add(cColor.value, props.id)
  bgColor.setBGColor(cColor.value)
  if(qrColorChange.value) {
    qColor.value = bgColor.background.value
    qHexColor.value = hexColor.value
  } else {
    bColor.value = bgColor.background.value
    bHexColor.value = hexColor.value
  }
  closeSettings()
}
const bColor = ref('#0D87EF')
const bHexColor = ref('#0D87EF')
const qColor = ref('#000000')
const qHexColor = ref('#000000')
const cColor = ref()

const hexColor = ref('')
const changeColor = (c, hex) => {
  hexColor.value = hex
  cColor.value = c
}

const fileInput = ref(null)
const rawFile = ref(null)
const previewUrl = ref(null)
const error = ref('')

const validateFile = async (val) => {
  error.value = ''
  if (previewUrl.value) {
    URL.revokeObjectURL(previewUrl.value)
    previewUrl.value = null
  }

  const file = Array.isArray(val) ? val[0] : val
  if (!file) return

  const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml']
  if (!allowedTypes.includes(file.type)) {
    return invalidate('Поддерживаются форматы JPG, PNG, GIF и SVG')
  }
  if (file.size > 4 * 1024 * 1024) {
    return invalidate('Размер файла превышает 4 МБ')
  }

  try {
    if (file.type !== 'image/svg+xml') {
      await checkDimensions(file)
    }

    qImage.value = await convertToBase64(file)
    previewUrl.value = URL.createObjectURL(file)

  } catch (err) {
    invalidate(err)
  }
}

const checkDimensions = (file) => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    const url = URL.createObjectURL(file)

    img.onload = () => {
      URL.revokeObjectURL(url)
      if (img.width < 150 || img.height < 150) {
        reject(`Минимальное разрешение — 150 × 150 пикс`)
      } else {
        resolve()
      }
    }

    img.onerror = () => {
      URL.revokeObjectURL(url)
      reject('Не удалось определить размер изображения. Попробуйте выбрать другой файл')
    }

    img.src = url
  })
}

const convertToBase64 = (f) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(f)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject('Ошибка при чтении файла')
  })
}

const invalidate = (msg) => {
  error.value = msg
  rawFile.value = null
  previewUrl.value = null
  qImage.value = null
}

const qrKey = computed(() => {
  return `${qImage.value?.length}-${bColor.value}-${qColor.value}`
})

const handleBInput = (event) => {
  const input = event.target;
  let rawValue = input.value;
  let hexPart = rawValue.replace(/#/g, '').toUpperCase();
  hexPart = hexPart.replace(/[^0-9A-F]/g, '');
  const finalValue = '#' + hexPart;
  bHexColor.value = finalValue;
  input.value = finalValue;

  bgColor.setBGColor(finalValue)
  bColor.value = bgColor.background.value
}

const handleQInput = (event) => {
  const input = event.target;
  let rawValue = input.value;
  let hexPart = rawValue.replace(/#/g, '').toUpperCase();
  hexPart = hexPart.replace(/[^0-9A-F]/g, '');
  const finalValue = '#' + hexPart;
  qHexColor.value = finalValue;
  input.value = finalValue;

  bgColor.setBGColor(finalValue)
  qColor.value = bgColor.background.value
}

const rgbaToHex = (r, g, b) => {
  const toHex = (n) => n.toString(16).padStart(2, '0').toUpperCase();
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

const formatColor = (color) => {
  if (color.startsWith('rgba(')) {
    return color.match(/\(([^)]+)\)/)[1];
  }
  return color;
}

const isColorValid = computed(() => {
  const pattern = /^#([A-Fa-f0-9]{3}){1,2}$/;
  return pattern.test(qHexColor.value) && pattern.test(bHexColor.value);
});

const QRViewRef = ref(null);
const downloadPNG = () => {
  QRViewRef.value?.downloadPNG()
}

const handleBeforeShare = async () => {
  if (QRViewRef.value) {
    await QRViewRef.value.initFile();
  }
};

const sharedFile = computed(() => QRViewRef.value?.shareFile);
const isLoading = computed(() => QRViewRef.value?.shareInProgress || false);
</script>

<style scoped lang="sass">
.qr-block
  background: #fff
  width: fit-content
  border-radius: 16px
  ::v-deep
    .qr
      display: flex
.background-block
  width: fit-content
  height: 240px
  min-width: 240px
  min-height: 240px
  border-radius: 16px
.color-title
  color: #363636
  text-align: center
  font-size: 20px
  font-weight: 600
  line-height: normal
.color-field
  border-radius: 8px
  border: 1px solid #CED4DA
  height: 40px
  width: 40px
  cursor: pointer
.file-block
  border-radius: 8px
  border: 1px dashed #B2B7BD
  flex-direction: column
  padding: 16px
  gap: 12px
  align-items: center
  .text
    color: #8D959D
    text-align: center
    font-size: 14px
    line-height: normal
    align-items: center
  &.selected
    justify-content: space-between
    padding: 24px 16px
    flex-direction: row
  .file-name
    white-space: nowrap
    text-overflow: ellipsis
    overflow: hidden
    font-size: 16px
    line-height: normal
  .separate
    flex: 1
</style>
